import React, { memo } from 'react';
import { useStyles } from 'uinix-ui';

import { ShimmerColor } from '../../system/styles/rules/shimmer';
import { Box } from '../Box/Box';

interface Props {
  height?: string;
  width?: string;
  mode?: 'rounded' | 'rectangular';
  lightColor?: ShimmerColor;
  darkColor?: ShimmerColor;
}

export const LoadingShimmer = memo(
  ({ height, width, mode = 'rectangular', lightColor, darkColor }: Props) => {
    const styles = useStyles();

    return (
      <Box
        role="status"
        borderRadius={mode === 'rounded' ? 'round' : 'none'}
        styles={styles.shimmer}
        styleProps={{ height, width, lightColor, darkColor }}
      />
    );
  },
);
